import { GenericAuthStateProps, CreateUserFormError, CreateUserProps, UserProps, stateStatusType } from './actionType';

export interface FetchUserstate {
    isLoading: boolean;
    error: string | null;
    users: UserProps[] | null;
    status: stateStatusType | null;
}
export const initialFetchUserstate: FetchUserstate = {
    isLoading: false,
    error: null,
    users: null,
    status: null
};
const initialCreateUserFormDataSate: CreateUserProps = {
    name: '',
    mobile_no: '',
    email: '',
    password: '',
    confirm_password: '',
    role_ids: []
};

export const initialGenericAuthState: GenericAuthStateProps = {
    isLoading: false,
    status: null,
    error: null
};

const initialCreateUserFormErrorState: CreateUserFormError = {
    name: null,
    mobile_no: null,
    email: null,
    password: null,
    confirm_password: null,
    emailOrMobile: null,
    role_ids: null,
};

export interface UserStateProps {
    fetchUsersState: FetchUserstate;
    createUserFormData: CreateUserProps;
    createUserFormError: CreateUserFormError;
    genericUserState: GenericAuthStateProps;
    checkForExistingUserByMobile: GenericAuthStateProps;
    checkForExistingUserByEmail: GenericAuthStateProps;
    children?: React.ReactNode;
}

export const initialState: UserStateProps = {
    fetchUsersState: initialFetchUserstate,
    createUserFormData: initialCreateUserFormDataSate,
    createUserFormError: initialCreateUserFormErrorState,
    genericUserState: initialGenericAuthState,
    checkForExistingUserByMobile: initialGenericAuthState,
    checkForExistingUserByEmail: initialGenericAuthState,
};
